import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../../../../services/apiService';
import VDeviceMixin from './mixin';
import { isNullOrEmpty } from '../../../../../../utils/vuex';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'CoreDtwinStateVirtualDeviceAggregateEdit',
  mixins: [VDeviceMixin],
  props: {
    // the current edited binding
    lclModel: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    twinType: {
      type: String,
      required: false,
      default: null
    },
    tenantId: {
      type: Number,
      required: true
    },
    // the original twin(/virtual-device)-model
    // to be used by some components for additional requesting data
    twinModel: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    dataSources: {
      type: Array,
      required: true
    },
    templateContext: {
      type: Boolean,
      required: false,
      default: false
    },
    stateDefinition: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      // the current result-set for the autocomplete device search
      virtualDevices: [],
      loadingDevices: false,
      virtualDeviceSearch: '',
      selectedVirtualDevice: null,
      // the retrieved states for the selected device
      virtualDeviceStates: null,
      // the key to find the found array of devices in `virtualDeviceFetch`
      virtualDeviceFetchVariable: 'virtualDevices'
    };
  },
  computed: {
    formIsValid: function formIsValid() {
      if (this.$refs['healthStateEdit']) {
        return this.$refs['healthStateEdit'].formIsValid;
      }

      return (this.templateContext || !isNullOrEmpty(this.selectedVirtualDevice)) && !isNullOrEmpty(this.selectedVirtualDeviceState) && this.selectedVirtualDeviceState.length > 0;
    },
    virtualDeviceConfigStates: function virtualDeviceConfigStates() {
      return get(this.lclModel, 'properties.binding.options.virtualDevice.stateIds');
    },
    stateObjects: function stateObjects() {
      return this.virtualDeviceStates;
    },
    virtualDeviceSourceName: function virtualDeviceSourceName() {
      return (this.dataSources.find(function (ds) {
        return ds.type === 'virtual-device';
      }) || {}).name || this.$i18n_t('DigitalTwin.VirtualDevice.title');
    }
  },
  watch: {
    virtualDeviceSearch: function virtualDeviceSearch(val) {
      if (!val || val.length < 1) {
        // if search value is empty or less than two characters do not start a search
        // but treat the old search as invalid as a new search is as about to happen
        // in this state no results will be shown in the auto-complete dropdown
        // because we set `virtualDevices` to an array with only `selectedVirtualDevice`
        // which will not show up because auto-completes `hide-selected` is true
        // while `loadingDevices` is true or the search is empty or less than two characters
        this.virtualDevices = [this.selectedVirtualDevice].filter(function (d) {
          return d;
        });
        return;
      } // do not trigger the device-search (again) after the item has been selected
      // that would clear the variable-set


      if (!this.selectedVirtualDevice || !this.selectedVirtualDevice.title || val !== this.selectedVirtualDevice.title) {
        // set loadingDevices to true as early as the debounced fetchDevices will be called
        // to not delay the loading state when settings it from the debounced method
        this.loadingDevices = true;
        this.fetchDevices();
      }
    },
    selectedVirtualDevice: function selectedVirtualDevice(val) {
      if (val !== null) {
        this.fetchStates();
      }

      this.emitSelection();
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.lclModel.properties.binding.options = _objectSpread(_objectSpread({}, this.lclModel.properties.binding.options), {}, {
      virtualDevice: _objectSpread({}, this.lclModel.properties.binding.options.virtualDevice)
    });
    this.lclModel.properties.binding.options.virtualDevice = _objectSpread(_objectSpread({}, this.lclModel.properties.binding.options.virtualDevice), {}, {
      stateIds: this.lclModel.properties.binding.options.virtualDevice.stateIds || [],
      health: this.lclModel.properties.binding.options.virtualDevice.health || []
    });

    if (this.templateContext) {
      this.fetchStates();
    }

    if (this.mode !== 'create' && this.mode !== 'import' && get(this.lclModel, 'properties.binding.options.virtualDevice.id')) {
      ApiService.virtualDeviceGet(this, get(this.lclModel, 'properties.binding.options.virtualDevice.id'), true).then(function (res) {
        var device = res;

        if (!device || !device.id) {
          throw new Error('NIOTA_DEVICE_NOT_FOUND');
        }

        _this.virtualDevices = device ? [device] : null;
        _this.selectedVirtualDevice = device;
      }).catch(function (error) {
        console.error(get(error, 'response.status'));

        if (get(error, 'response.status') === 403) {
          // user has no permission to read the device
          // probably some other user linked it, and this user cannot read it
          // so emit the no-permission event here to trigger the edit-dialog to be closed
          _this.$emit('no-permission', _this.$i18n_t('DigitalTwin.DigitalTwin.states.noPermissionError'));

          return;
        }

        console.error(error);
        var errorMessage = get(error, 'response.data.message', error.message);
        var errorOutput = _this.$i18n_te("Error.".concat(errorMessage)) ? _this.$i18n_t("Error.".concat(errorMessage)) : _this.$i18n_t(errorMessage);

        _this.$snack(errorOutput, 'error');

        _this.virtualDevices = null;
        _this.selectedVirtualDevice = null;
      }).finally(function () {
        _this.loading = false;
      });
    }
  },
  methods: {
    cloneDeep: cloneDeep,
    bridgeBindingChanged: function bridgeBindingChanged(e) {
      if (!isEqual(this.lclModel.properties.binding.options.virtualDevice, e.config) || !isEqual(this.lclModel.value.value, e.value)) {
        this.lclModel.properties.binding.options.virtualDevice = e.config;
        this.lclModel.value.value = e.value;
        this.$emit('bridge-binding-changed', e);
      }
    },
    emitSelection: function emitSelection() {
      if (this.$refs['healthStateEdit']) {
        this.aggregateStateValue = this.$refs['healthStateEdit'].emitSelection();
        return;
      }

      var aggregateStateValue = {};
      this.selectedVirtualDeviceState.forEach(function (aggVar) {
        aggregateStateValue[aggVar.key] = get(aggVar, 'value.value');
        aggregateStateValue["".concat(aggVar.key, "_time")] = get(aggVar, 'value.time');
      });
      this.aggregateStateValue = aggregateStateValue;
      this.$emit('bridge-binding-changed', {
        identifier: get(this.selectedVirtualDevice, 'id'),
        valueType: get(this.selectedVirtualDeviceState, '[0].properties.valueType'),
        variable: get(this.selectedVirtualDeviceState, '[0].key'),
        value: this.aggregateStateValue
      });
    },
    // put the request in separate function, in case some components needs to overwrite it with own logic
    // e.g. in the heat-monitoring module where a custom list of "meters" with custom search-filter needs to be requested
    fetchRequest: function fetchRequest() {
      return ApiService.virtualDeviceFetch(this, null, null, null, ['bare'], null, 0, 50, [{
        or: [{
          variable: 'title',
          search: this.virtualDeviceSearch
        }, {
          variable: 'id',
          search: this.virtualDeviceSearch
        }]
      }]);
    },
    fetchDevices: debounce(function () {
      var _this2 = this;

      this.loadingDevices = true;
      this.fetchRequest().then(function (res) {
        _this2.virtualDevices = get(res, _this2.virtualDeviceFetchVariable) || [];
      }).catch(function (error) {
        console.error(error);
        var errorMessage = get(error, 'response.data.message', error.message);
        var errorOutput = _this2.$i18n_te("Error.".concat(errorMessage)) ? _this2.$i18n_t("Error.".concat(errorMessage)) : _this2.$i18n_t(errorMessage);

        _this2.$snack(errorOutput, 'error'); // logException(error);


        _this2.virtualDevices = [];
      }).finally(function () {
        _this2.loadingDevices = false;
      });
    }, 250),
    fetchStates: function fetchStates() {
      var _this3 = this;

      this.virtualDeviceStates = null;

      if (this.templateContext) {
        this.virtualDeviceStates = this.stateDefinition || [];
        return;
      }

      if (!get(this, 'selectedVirtualDevice.id')) {
        return;
      }

      ApiService.digitalTwinFetchStates(this, this.selectedVirtualDevice.id).then(function (states) {
        _this3.virtualDeviceStates = states.map(_this3.mapStateToUi);
        _this3.selectedVirtualDeviceState = cloneDeep(_this3.virtualDeviceStates.map(function (s) {
          if (_this3.selectedVirtualDeviceState.findIndex(function (s1) {
            return s1.key === s.key;
          }) >= 0) {
            return s;
          }

          return null;
        }).filter(function (s) {
          return s;
        }));
      }).catch(function (error) {
        console.error(error);
        var errorMessage = get(error, 'response.data.message', error.message);
        var errorOutput = _this3.$i18n_te("Error.".concat(errorMessage)) ? _this3.$i18n_t("Error.".concat(errorMessage)) : _this3.$i18n_t(errorMessage);

        _this3.$snack(errorOutput, 'error'); // logException(error);


        _this3.virtualDeviceStates = [];
      });
    },
    saveState: function saveState() {
      if (this.$refs['healthStateEdit']) {
        this.$refs['healthStateEdit'].saveState();
        return;
      }

      this.lclModel.properties.binding.options.virtualDevice = {
        id: get(this.selectedVirtualDevice, 'id'),
        stateIds: (this.selectedVirtualDeviceState || []).map(function (s) {
          return s.id || s.key;
        })
      };
    }
  }
};